import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideSubscriptionLeg } from './ride-subscription-leg';

@inheritSerialization(AbstractModel)
export class RideSubscriptionDetail extends AbstractModel {
  @autoserialize
  riderFirstName: string;

  @autoserialize
  riderLastName: string;

  @autoserialize
  organizationCode: string;

  @autoserialize
  serviceLevelCode: string;

  @autoserialize
  subscriptionDays: Array<string>;

  @autoserializeAs(Date)
  startDate: Date;

  @autoserializeAs(Date)
  endDate: Date;

  @autoserialize
  timeZone: string;

  @autoserializeAs(RideSubscriptionLeg)
  rideSubscriptionLegs: Array<RideSubscriptionLeg>;

  static OnSerialized(instance: RideSubscriptionDetail, json: any): void {
    super.OnSerialized(instance, json);
    if (!isNullOrUndefined(instance.startDate)) {
      json.startDate = DateUtil.serializeLocalDate(instance.startDate);
    }
    if (!isNullOrUndefined(instance.endDate)) {
      json.endDate = DateUtil.serializeLocalDate(instance.endDate);
    }
  }

  static OnDeserialized(instance: RideSubscriptionDetail, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['startDate'])) {
      instance.startDate = DateUtil.deserializeLocalDate(json['startDate']);
    }

    if (!isNullOrUndefined(json['endDate'])) {
      instance.endDate = DateUtil.deserializeLocalDate(json['endDate']);
    }
  }
}
